// Menu configuration - This can be stored in a database for CRUD operations
// For now, it's a static config that simulates dynamic menu structure

export interface MenuItem {
  id: string;
  label: string;
  href?: string;
  icon?: string;
  external?: boolean;
  children?: MenuItem[];
  featured?: {
    title: string;
    description: string;
    image: string;
    href: string;
  };
}

export interface MenuGroup {
  id: string;
  label: string;
  type: 'link' | 'dropdown' | 'megamenu';
  href?: string;
  items?: MenuItem[];
  columns?: number; // for mega menu layout
}

// Static menus - Core navigation
export const staticMenus: MenuGroup[] = [
  {
    id: 'beranda',
    label: 'Beranda',
    type: 'link',
    href: '/',
  },
  {
    id: 'profil',
    label: 'Profil',
    type: 'megamenu',
    columns: 2, // Reduced from 3 since Layanan is removed
    items: [
      {
        id: 'tentang',
        label: 'Tentang',
        children: [
          { id: 'sejarah', label: 'Sejarah & Visi Misi', href: '/profil/sejarah-visi-misi' },
          { id: 'struktur', label: 'Struktur Organisasi', href: '/profil/struktur-organisasi' },
          { id: 'pimpinan', label: 'Pimpinan', href: '/profil/pimpinan' },
          { id: 'peta', label: 'Peta Kampus', href: '/profil/peta-kampus' },
        ],
      },
      {
        id: 'akademik-info',
        label: 'Akademik',
        children: [
          { id: 'pendaftaran', label: 'Pendaftaran', href: '/pendaftaran' },
          { id: 'akademik', label: 'Informasi Akademik', href: '/akademik' },
          // Fakultas removed
          // Riset & Inovasi removed
        ],
      },
      // Layanan section removed entirely
    ],
  },
 
  {
    id: 'informasi',
    label: 'Informasi',
    type: 'dropdown',
    items: [
      {
        id: 'informasi-section',
        label: '',
        children: [
          { id: 'berita', label: 'Berita', href: '/berita' },
          { id: 'pengumuman', label: 'Pengumuman', href: '/pengumuman' },
          { id: 'buletin', label: 'Buletin', href: '/buletin' },
          { id: 'galeri', label: 'Galeri', href: '/galeri' },
          { id: 'ppid', label: 'PPID', href: '/ppid' },
        ],
      },
    ],
  },
  {
    id: 'event',
    label: 'Event',
    type: 'dropdown',
    items: [
      {
        id: 'event-section',
        label: '',
        children: [
          { id: 'penelitian-pelatihan', label: 'Penelitian & Pelatihan', href: '/event/penelitian-pelatihan' },
          { id: 'seminar-webinar', label: 'Seminar & Webinar', href: '/event/seminar-webinar' },
          { id: 'lainnya', label: 'Lainnya', href: '/event/lainnya' },
        ],
      },
    ],
  },
];

// Dynamic menus - Can be managed via CMS/Admin panel
// This would typically come from an API/database
export const dynamicMenus: MenuGroup[] = [
  // Converted Layanan to MEGA MENU (like Profil)
  
  // NEW: Example Dynamic Mega Menu (simulating CMS-driven content)
  {
    id: 'pusat-riset',
    label: 'Riset & Publikasi',
    type: 'megamenu',
    columns: 2,
    items: [
      {
        id: 'pusat-riset-section',
        label: 'Pusat Riset',
        children: [
          { id: 'lp2m', label: 'LP2M', href: '#' },
          { id: 'pusat-studi', label: 'Pusat Studi Tropis', href: '#' },
          { id: 'lab-unggulan', label: 'Laboratorium Unggulan', href: '#' },
          { id: 'haki', label: 'HaKI & Paten', href: '#' },
        ],
      },
      {
        id: 'publikasi-section',
        label: 'Publikasi Ilmiah',
        children: [
          { id: 'jurnal-unmul', label: 'Jurnal UNMUL', href: 'https://jurnal.unmul.ac.id', external: true },
          { id: 'prosiding', label: 'Prosiding Konferensi', href: '#' },
          { id: 'repository-riset', label: 'Repository Riset', href: 'https://repository.unmul.ac.id', external: true },
          { id: 'scopus', label: 'Artikel Terindeks', href: '#' },
        ],
      },
    ],
  },
];

// Combine all menus
export const getAllMenus = (): MenuGroup[] => {
  return [...staticMenus, ...dynamicMenus];
};

// Helper to add a dynamic menu (for CRUD simulation)
export const addDynamicMenu = (menu: MenuGroup): void => {
  dynamicMenus.push(menu);
};

// Helper to get menu by ID
export const getMenuById = (id: string): MenuGroup | undefined => {
  return getAllMenus().find(m => m.id === id);
};
